/* eslint-disable */
const filterCounter         = $('.filter-counter');
const exportBtn				= $('a#export');
let   applicantIdsForExport	= [];

export default {
  init() {

  },
  finalize() {

    $(exportBtn).on('click touch', function(e) {
		e.preventDefault();
		$(exportBtn).append('<div class="spinner"></div>').addClass('processing');

		applicantIdsForExport.length = 0;

		$.each($('.row-applicant:visible'), function(){
			var thisID = $(this).data('id');
			applicantIdsForExport.push(thisID);
		});

		$.ajax({
			type : 'POST',
			dataType : 'json',
			url : myAjax.ajaxurl,
			data : {
				action: 'export_applicants',
				applicants : applicantIdsForExport,
				_wpnonce: myAjax.export_applicants_nonce
			},
			success: function (response) {
				if (response.success) {
					alert(response.data.message);
					window.location.href = response.data.file_url; // Triggers download
				} else {
					alert('Error: ' + response.data.message);
				}

				exportBtn.removeClass('processing').children().remove();
			},
			error: function (response) {
				alert('An error occurred while exporting.');
				console.log(response);
			}
		})


    });


    $('.update-status').on('click touch', function(e){
      e.preventDefault();
      let status =  $(this).data('status'),
          parent  = $(this).parents('.row-applicant'),
          id      = parent.data('id');


      parent.css('opacity', 0.5);

      $.ajax({
         type : "post",
         dataType : "json",
         url : myAjax.ajaxurl,
         data : {action: "update_applicant", applicant_id : id, app_status: status},
         success: function(response) {
            if(response.type == "success") {
              setTimeout(function(){
                if(response.new_term == 'archive') {
                  parent.animate({ height: 0 }, 500, function(){
                    parent.remove();
                    let visibleElems = $('.hentry:visible');
                    if(filterCounter) filterCounter.html(visibleElems.length);
                  });
                } else {
                  parent.css('opacity', 1);
                  parent.find('.update-status').remove();
                  parent.find('.applicant-status').html(response.new_term);
                }

              }, 500);
            }
            else {
               alert("Something went wrong, please reload the page.")
            }
         },
      })

    })

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archiveApplicant.js